$(function() {

	$('#columns').each(function() {

		var $columns = $(this),
			$form = $('#columns-form'),
			busy = false;

		function close(e) {
			if (busy) return false;
			busy = true;
			$('body').removeClass('columns-animated');
			setTimeout(function() {
				$('body').removeClass('columns-visible');
				busy = false;
			}, 300);
			return false;
		}

		function open(e) {
			if ($(this).parent().hasClass('disabled')) return false;
			if (busy) return false;
			busy = true;
			e.stopPropagation();
			$('body').addClass('columns-visible');
			setTimeout(function() {
				$('body').addClass('columns-animated');
				window.serendis.initSelect2();
				$('#columns .column').first().filter(':text').focus().select();
				busy = false;
			}, 100);
			return false;
		}

		$('#show-columns').click(open);

		$('#columns-cancel').click(close);

		$(window).keyup(function(e) {
			if (e.which === 27) close();
		});

		$(window).click(function(e) {
			if ($(e.target).attr('id') != 'columns' && !$(e.target).parents('#columns').length && !$(e.target).hasClass('select2-selection__choice__remove')) {
				close();
			}
		});

		// Checkboxes
		var $allCheckbox = $form.find('input[name="columns_all"]'),
			$otherCheckboxes = $form.find('input:checkbox').not('[name="columns_all"]');
		$allCheckbox.change(function() {
			$otherCheckboxes.prop('checked', $allCheckbox.prop('checked'));
		});
		$otherCheckboxes.change(function() {
			var allChecked = $otherCheckboxes.length == $otherCheckboxes.filter(':checked').length;
			$allCheckbox.prop('checked', allChecked);
		});

		// Filter checkboxes
		var $checkboxFilter = $('#columns_filter');
		$checkboxFilter.on('input', function() {
			$form.find('.checkbox-child').hide();
			$form.find('.checkbox-child').filter(function() {
				return new RegExp($checkboxFilter.val(), 'gi').test($(this).attr('data-title'));
			}).show();
		});

		// Reset
		$('#columns-reset').click(function() {
			$otherCheckboxes.prop('checked', false);
			$form.submit();
			return false;
		});

	});

});